import { AppRoutes } from './AppRoutes';
import React, { PropsWithChildren } from 'react';
import useAuth from '../auth/authContext';
import { Navigate } from 'react-router-dom';
import { Permission } from '../auth/permissions';

export const ProtectedRoute = (
  props: {
    permission: Permission;
  } & PropsWithChildren
) => {
  const { permission, children } = props;
  const {
    state: { user },
  } = useAuth();

  return !(!user || !user.has(permission)) ? (
    <>{children}</>
  ) : (
    <Navigate
      to={{
        pathname: AppRoutes.NotFound,
      }}
      state={{}}
    />
  );
};
